module.exports = __webpack_public_path__ + "static/media/medicine.f12182e5.png";